// removed by extract-text-webpack-plugin
module.exports = {"Footer":"style__Footer___3Y-3u","Documents":"style__Documents___2USAE","DocumentLinks":"style__DocumentLinks___1c2Dd","FooterLink":"style__FooterLink___26Q-E","FooterDeveloper":"style__FooterDeveloper___3N-q_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/style.scss
// module id = 1409
// module chunks = 0